export const thumbnailConstants = {
  THUMBNAIL_SIZE: 50,
  THUMBNAIL_MODEL_COLOUR: "#ffaa00",
  THUMBNAIL_MODEL_LIGHT: "#cccccc"
};
